import { render, staticRenderFns } from "./SectorTag.vue?vue&type=template&id=1369347b"
import script from "./SectorTag.vue?vue&type=script&lang=js"
export * from "./SectorTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports